import React, { useEffect, useState } from 'react'
import { Box, Grid, IconButton, Pagination, Stack } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import { isNotEmpty } from '../../../utils/format';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import route from '../../../utils/Routes';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert } from '../../../components/notify';
import ProductCard from '../../../components/ProductCard';
import CatCard from '../../../components/CatCard';
import SearchTxtField from '../../../components/SearchTxtField';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import PathBtns from '../../../components/PathBtns';
import { getComProdServ, getComSubCatServ } from '../../../services/com-service';

function ComSubCategoryPage({ type = 'amtc' }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const catId = parseInt(searchParams.get("catId"));
    const catName = searchParams.get("catName");
    const qcomId = searchParams.get("comId");
    const comId = type === 'amtc' ? qcomId : ctxtUser?.comId;
    const limit = 12;
    const prPageNumber = parseInt(searchParams.get("prPageNumber") || "1");
    const caPageNumber = parseInt(searchParams.get("caPageNumber") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const isSrchRes = parseInt(searchParams.get("isSrchRes") || "0");
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const [caOrder, setCaOrder] = useState('desc');
    const { isLoading: isCatLoading, isError: isCatErr, error: catErr, data: catData } = useQuery([QueryKey.amtcSubCat, comId, limit, caPageNumber, caOrder, catId],
        () => getComSubCatServ({ comId, catId, limit, pageNumber: caPageNumber, order: caOrder }), {
        enabled: (isNotEmpty(catId) && isNotEmpty(comId)),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.comProd, comId, limit, prPageNumber, isSrchBtnClick],
        () => getComProdServ({ comId, limit, pageNumber: prPageNumber, searchKeyWord: searchWord }), {
        enabled: isSrchRes === 1,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const pathBtnsArr = type === 'amtc' ? [{
        label: "Category",
        handleClick: () => navigate(`${route.aCompany}/?comId=${comId}&tab=2`)
    }, {
        label: catName,
        handleClick: () => { }
    }] : [{
        label: "Category",
        handleClick: () => navigate(`${route.comCataLog}`)
    }, {
        label: catName,
        handleClick: () => { }
    }]

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    useEffect(() => {
        if (!catId) {
            navigate("/", { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catId]);

    useEffect(() => {
        setLoadingScreen(isCatLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCatLoading]);

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);

    async function onOrderChange(e) {
        if (caOrder === "desc")
            setCaOrder("asc");
        else
            setCaOrder("desc");
        setSearchParams(prev => {
            prev.set("caPageNumber", 1)
            return prev
        }, { replace: true })
    }

    function handleSubCatCardClick(i) {
        if (type === 'amtc')
            navigate(`${route.aComProdList}/?subCatId=${i?.id}&comId=${comId}`);
        else
            navigate(`${route.cProdsList}/?subCatId=${i?.id}`);
    }

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("isSrchRes", 1)
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("s", "")
            prev.set("isSrchRes", 0)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    const handlePrPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("prPageNumber", value)
            return prev
        }, { replace: true })
    };

    const handleCaPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("caPageNumber", value)
            return prev
        }, { replace: true })
    };


    if (isCatErr) {
        customAlert(catErr);
        return <h2>Something went wrong</h2>
    }

    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"}>

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Stack width={"33%"} direction={"row"} alignItems={"center"} gap={1}>
                    <BackButton />
                    <PathBtns btnsArr={pathBtnsArr} />
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <Box mb={0.5}><SearchTxtField handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} width={400}
                        onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer`} />
                    </Box>
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    {isSrchRes === 1 ? <></> : <IconButton onClick={onOrderChange}>
                        <SwapVertOutlinedIcon />
                    </IconButton>}

                </Stack>
            </Stack>

            {isSrchRes === 1 ? <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} type='com' comId={comId} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                        page={prPageNumber} onChange={handlePrPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </> : <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(catData?.subCatsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <CatCard i={i} key={i?.id} handleClick={handleSubCatCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(catData?.totalCatCount / limit) || 0} color="primary" page={caPageNumber} onChange={handleCaPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </>}

        </Box>
    )
}
export default ComSubCategoryPage;